import {IConfig} from './i-config';

export class Config {
    constructor(public orientationtestUrl: URL,
				public beroepenlijstUrl: URL,
                public brpchartEnvironment: string | null,
				public cijfergegevensEnabled: boolean,
				public voegVaardighedenToeUrl?: URL) {
    }

    public static fromInterface(iConfig: IConfig): Config {
        return new Config(
            iConfig.orientationtestUrl,
			iConfig.beroepenlijstUrl,
            iConfig.brpchartEnvironment,
			iConfig.cijfergegevensEnabled,
			iConfig.voegVaardighedenToeUrl
        );
    }
}
